import { render, staticRenderFns } from "./dictionaryType.vue?vue&type=template&id=d0e3d80e&scoped=true"
import script from "./dictionaryType.vue?vue&type=script&lang=js"
export * from "./dictionaryType.vue?vue&type=script&lang=js"
import style0 from "./dictionaryType.vue?vue&type=style&index=0&id=d0e3d80e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e3d80e",
  null
  
)

export default component.exports